<script setup lang="ts">
import { computed, defineEmits, defineProps, watch } from 'vue'
import BaseInputWrapper from './BaseInputWrapper.vue'
import { useField } from 'vee-validate'

const props = defineProps<{
    modelValue: string | boolean
    label?: string
    name: string
    required?: boolean
    required2?: boolean
    rules?: any
    standalone?: boolean
}>()
const { handleChange } = useField(props.name, props.rules, {
    standalone: props.standalone ? props.standalone : false,
    initialValue: props.modelValue,
})

const emit = defineEmits(['update:modelValue'])

function updateValue(value) {
    handleChange(value)
    emit('update:modelValue', value)
}

watch(
    () => props.modelValue,
    (value) => {
        handleChange(value)
    }
)

const value = computed({
    get: () => props.modelValue,
    set: (value) => {
        updateValue(value)
    },
})
</script>
<template>
    <BaseInputWrapper :name="props.name" :required="required" :required2="required2" :standalone="standalone">
        <div class="relative flex items-center">
            <div class="flex h-5 items-center">
                <input
                    :id="props.name"
                    v-model="value"
                    aria-describedby="comments-description"
                    name="comments"
                    v-bind="$attrs"
                    type="checkbox"
                    class="h-6 w-6 rounded-md border-gray-300 text-primary focus:ring-primary disabled:bg-gray-400" />
            </div>
            <slot>
                <div class="ml-2 text-sm">
                    <label :for="props.name" class="font-medium text-gray-700">{{ label }}</label>
                </div>
            </slot>
        </div>
    </BaseInputWrapper>
</template>
